 $(function() {

  var count = 1;
  var lisize = $("#MobileNavFooter > li").length;
    
  $("#MobileNavFooter li").each(function() {
    if ($(this).children("ul").children("li").length > 0) {
      $(this).children("a").attr("href", ".collapse" + count);
      $(this).children("a").attr("data-toggle", "collapse");
      $(this).children("ul").addClass("collapse collapse" + count);
      count++;
    }
  });

});
  